export default "__VITE_ASSET__7FFFv9W3__"